<template>
  <WorkGuidanceFloatingBall
    v-if="workGuidance.enabled && showBall"
    :label="workGuidance.buttonText || '工作指引'"
    @click="openDialog"
  />
  <WorkGuidanceDialog v-model="showDialog" :config="workGuidance" />
</template>

<script>
import { getWorkGuidance } from '@/services/api'
import WorkGuidanceDialog from '@/components/WorkGuidanceDialog.vue'
import WorkGuidanceFloatingBall from '@/components/WorkGuidanceFloatingBall.vue'

export default {
  name: 'WorkGuidanceEntry',
  components: {
    WorkGuidanceDialog,
    WorkGuidanceFloatingBall
  },
  emits: ['loaded'],
  props: {
    showBall: { type: Boolean, default: true }
  },
  data() {
    return {
      workGuidance: { enabled: false },
      showDialog: false
    }
  },
  mounted() {
    this.loadWorkGuidance()
  },
  methods: {
    async loadWorkGuidance() {
      try {
        const { data } = await getWorkGuidance()
        this.workGuidance = data?.enabled ? data : { enabled: false }
        this.$emit('loaded', this.workGuidance)
      } catch (e) {
        console.warn('加载工作指引失败:', e)
        this.workGuidance = { enabled: false }
        this.$emit('loaded', this.workGuidance)
      }
    },
    openDialog() {
      if (this.workGuidance.enabled) {
        this.showDialog = true
      }
    }
  }
}
</script>
